module.exports = __webpack_public_path__ + "img/reefer.28b0acd6.svg";